import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Input } from "../../library/input";
import { Popup } from "../../library/popup";
import { loadStripe } from "@stripe/stripe-js";
import { changeUniversalModal } from "../../../redux/actions/universal";
import { sendErrorNotification } from "../../universal/notifications/notifications";
import { requestValidateNewSpace } from "../../../redux/actions/new-space";
import { TransparentButton, SolidButton } from "../../library/button";
import "./style.scss";
import { Label } from "../../library/label";

const Index = () => {
  const stripePromise = loadStripe(
    `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`
  );

  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.universal.showModals.newSpaceModal
  );

  const [loading, setLoading] = useState(false);

  const label = useSelector((state) => state.newSpace.buttonStatus);

  const newSpaceStatus = useSelector(
    (state) => state.newSpace.createNew.status
  );
  const newSpaceError = useSelector((state) => state.newSpace.createNew.error);

  const checkoutData = useSelector((state) => state.newSpace.checkoutData);

  const [organizationNumber, setOrganizationNumber] = useState("");

  const handleClose = () => {
    dispatch(changeUniversalModal({ newSpaceModal: false }));
  };

  useEffect(() => {
    if (newSpaceError) {
      sendErrorNotification("Kunne ikke validere bedrift.");
      setLoading(false);
    }
  }, [newSpaceError]);

  useEffect(() => {
    if (newSpaceStatus) {
      navigateCheckout();
    }
  }, [newSpaceStatus, checkoutData]);

  const navigateCheckout = async () => {
    try {
      const stripe = await stripePromise;
      fetch("/api/stripe/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "newspace",
          trial: checkoutData.trialEligible,
          organizationNumber: checkoutData.organizationNumber,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          stripe.redirectToCheckout({ sessionId: result.sessionId });
        });
    } catch (e) {
      setLoading(false);
      sendErrorNotification("Kunne ikke gå til betaling.");
    }
  };

  const validateCompany = () => {
    setLoading(true);
    dispatch(
      requestValidateNewSpace({ organizationNumber: organizationNumber })
    );
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Opprett et nytt miljø"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={handleClose}
        />,
        <SolidButton
          disabled={organizationNumber.length !== 11 ? true : false}
          color="blue"
          title={loading ? "Går til betaling..." : "Gå til betaling"}
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin" />
            ) : (
              <i class="fad fa-shopping-cart" />
            )
          }
          onClick={() => validateCompany()}
          type="button"
        />,
      ]}
    >
      <div className="new-space-modal-content">
        <div className="select-plan-container">
          <div className="single-selection-container active">
            <div className="inner-single-selection-container">
              <Row>
                <Col className="button-col my-auto">
                  <button className="select-button">
                    <i class="fad fa-circle"></i>
                  </button>
                </Col>
                <Col className="details-col my-auto">
                  <h4 className="plan-title">Standard abonnement</h4>
                  <p className="plan-description">
                    Pris oppgitt er eksklusiv moms
                  </p>
                </Col>
                <Col className="price-col my-auto">
                  <span className="price-display">
                    399kr<span className="small">per måned</span>
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Row className="input-row">
          <Col className="input-col">
            <Label version={1} weight="bold">
              Organisasjonsnummer
            </Label>
            <Input
              placeholder="Organisasjonsnummer"
              value={organizationNumber}
              onChange={(e) => setOrganizationNumber(e.target.value)}
              format="organizationNumber"
            />
          </Col>
        </Row>
      </div>
    </Popup>
  );
};

export default Index;
